import { Country, GlobalRegion, Plan, Region } from '../interfaces/cached-content';
import { SimSubscription } from '../interfaces/sims';

export type PlanDetails =
  | { type: 'region'; entity: Region; plan: Plan }
  | { type: 'country'; entity: Country; plan: Plan }
  | { type: 'global'; entity: GlobalRegion; plan: Plan }
  | null;

export const PlanDetailsFromSimSubscription = (
  plan: SimSubscription,
  countries: Country[],
  regions: Region[],
  globalRegions: GlobalRegion[]
): PlanDetails => {
  switch (plan.regionType) {
    case 'country': {
      const country: Country | undefined = countries.find(
        (country) => country.iso3code === plan.planData.supportedCountries[0]
      );

      if (!country) {
        return null;
      }

      const entityPlan = country.plans.find(
        (countryPlan) => countryPlan.productId === plan.productId
      );

      return entityPlan ? { type: 'country', entity: country, plan: entityPlan } : null;
    }
    case 'region': {
      const region = regions.find((region) => region.name === plan.country);
      if (!region) {
        return null;
      }

      const entityPlan = region.plans.find((regionPlan) => regionPlan.productId === plan.productId);
      return entityPlan ? { type: 'region', entity: region, plan: entityPlan } : null;
    }
    case 'global': {
      const globalRegion = globalRegions.find(
        (region) => region.name.toLocaleLowerCase() === plan.country.toLocaleLowerCase()
      );
      if (!globalRegion) {
        return null;
      }

      const entityPlan = globalRegion.plans.find(
        (regionPlan) => regionPlan.productId === plan.productId
      );
      return entityPlan ? { type: 'global', entity: globalRegion, plan: entityPlan } : null;
    }
    default:
      return null;
  }
};
